module.exports = __webpack_public_path__ + "static/img/wind.45980ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/address/wind.jpg
// module id = Hlyw
// module chunks = 0